import React from "react"

import enJSON from "../../public/locales/en/translation"
import trJSON from "../../public/locales/tr/translation"

// Booklet PDF mapping: translation subKey → PDF file path
const BOOKLET_LINKS = {
  nginrDescriptionPartFour: "/booklets/nginrsBooklet.pdf",
  nginrDescriptionPartFive: "/booklets/nginrmBooklet.pdf",
  hymotsDescriptionPartFive: "/booklets/Hymots_Booklet.pdf",
  etecubeBooklet: "/booklets/Etecube_Booklet.pdf",
  artsBooklet: "/booklets/Arts_Booklet.pdf",
  hymotsBooklet: "/booklets/Hymots_Booklet.pdf",
  nginrBooklet: "/booklets/Nginr_Booklet.pdf",
}

const DEFAULT_BOOKLET_LINK = "./booklets/ETECube.pdf"

const LINK_TRIGGER = { en: "here", tr: "buraya" }

const LINK_STYLE = { color: "#347768", fontWeight: 700, textDecoration: "underline" }

const formatJSON = (json, language) => {
  const triggerWord = LINK_TRIGGER[language]
  const result = {}

  Object.keys(json).forEach(sectionKey => {
    result[sectionKey] = {}
    Object.keys(json[sectionKey]).forEach(subKey => {
      // Step 1: Split by <0></0> tags → wrap odd segments in <sup>
      const supParts = json[sectionKey][subKey].split(/<0>|<\/0>/g)

      const withSup = supParts.map((text, i) =>
        i % 2 !== 0 ? <sup key={`sup-${i}`}>{text}</sup> : text
      )

      // Step 2: Split by <1></1> tags → wrap matching text in <a> booklet links
      result[sectionKey][subKey] = withSup.map(part => {
        if (typeof part !== "string") return part

        const linkParts = part.split(/<1>|<\/1>/g)
        return linkParts.map((text, i) => {
          if (i % 2 === 0) return text
          if (text === triggerWord) {
            const href = BOOKLET_LINKS[subKey] || DEFAULT_BOOKLET_LINK
            return (
              <a
                style={LINK_STYLE}
                href={href}
                key={`link-${i}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {text}
              </a>
            )
          }
          return text
        })
      })
    })
  })

  return result
}

export const getLanguageFile = language => {
  return language === "en" ? formatJSON(enJSON, "en") : formatJSON(trJSON, "tr")
}
